import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

const Services = () => {
  const serviceData = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        limit: 3
        filter: { frontmatter: { type: { eq: "service" } } }
        sort: { fields: frontmatter___title }
      ) {
        edges {
          node {
            excerpt
            fields {
              slug
            }
            frontmatter {
              title
              featured {
                image
              }
            }
            html
          }
        }
      }
    }
  `)

  return (
    <div className='wrapper pb-30'>
      <h3 className='titleWithLine py-5'>HİZMETLER</h3>
      <div className='grid'>
        {serviceData.allMarkdownRemark.edges.map(edge => {
          return (
            <div className='infoBox2'>
              <div className='infoBoxCircle2'>
                <img
                  src={edge.node.frontmatter.featured.image}
                  alt={edge.node.frontmatter.title}
                />
              </div>
              <h3>{edge.node.frontmatter.title}</h3>
              <p>{edge.node.excerpt}</p>
              <Link
                className='infoBox2Link'
                to={`/hizmetler/${edge.node.fields.slug}`}
              >
                <div className='rightArrow'></div>
              </Link>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Services
